const { upgradeArray } = require('../utils')

const COMMUNICATION_TYPES = upgradeArray([ 'outgoing-message-request', 'outgoing-message-status', 'incoming-message-request' ])

module.exports = {
  COMMUNICATION_TYPES
}
